export enum FormAction {
  None,
  EndOfPhase,
  EndOfProgram
}
